import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, MessageCircleIcon, VideoIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-brand-bg pt-8 md:pt-12 pb-8 md:pb-10 relative overflow-hidden" data-id="element-246">
      <div className="absolute bottom-0 left-0 right-0 h-[70%] bg-gradient-to-t from-[#22c55e]/10 via-[#22c55e]/5 to-transparent pointer-events-none" data-id="element-247" />
      <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-248" />

      {/* Title + Subtitle — NEON BLACK PANEL */}
      <div className="relative w-full -mt-8 md:-mt-12 overflow-hidden bg-black" data-id="element-249">
        {/* Neon radial glows: pink, violet, blue */}
        <div className="absolute -top-1/3 left-[10%] w-[700px] h-[700px] bg-[#ec4899]/[0.22] rounded-full blur-[140px] pointer-events-none" data-id="element-250" />
        <div className="absolute -top-1/4 right-[5%] w-[700px] h-[700px] bg-[#3b82f6]/[0.20] rounded-full blur-[140px] pointer-events-none" data-id="element-251" />
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-[#a855f7]/[0.18] rounded-full blur-[150px] pointer-events-none" data-id="element-252" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-[#ec4899]/[0.14] rounded-full blur-[100px] pointer-events-none" data-id="element-253" />

        {/* Hairline borders with neon gradient */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#ec4899]/70 via-[#a855f7]/70 to-transparent" data-id="element-254" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#3b82f6]/70 via-[#a855f7]/70 to-transparent" data-id="element-255" />

        <div className="relative z-10 max-w-5xl mx-auto text-center px-6 py-20 md:py-28" data-id="element-256">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-257">
            {/* Eyebrow */}
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-258">
              <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#ec4899]" data-id="element-259" />
              <span className="uppercase tracking-[0.35em] text-xs md:text-sm font-semibold bg-gradient-to-r from-[#ec4899] via-[#a855f7] to-[#3b82f6] bg-clip-text text-transparent" data-id="element-260">
                Emprende Digital
              </span>
              <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#3b82f6]" data-id="element-261" />
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] max-w-5xl mx-auto text-center tracking-tight" style={{
            fontFamily: "'Playfair Display', Georgia, serif"
          }} data-id="element-262">
              Genera tus primeros{' '}
              <span className="bg-gradient-to-r from-[#ec4899] via-[#a855f7] to-[#3b82f6] bg-clip-text text-transparent" data-id="element-263">
                $1,000 dólares mensuales
              </span>{' '}
              vendiendo tu{' '}
              <span className="bg-gradient-to-r from-[#ec4899] via-[#a855f7] to-[#3b82f6] bg-clip-text text-transparent" data-id="element-264">
                ebook digital
              </span>{' '}
              en solo{' '}
              <span className="bg-gradient-to-r from-[#ec4899] via-[#a855f7] to-[#3b82f6] bg-clip-text text-transparent" data-id="element-265">
                7 días
              </span>
            </h1>

            <div className="flex justify-center mt-8 mb-2" data-id="element-266">
              <div className="w-32 h-px bg-gradient-to-r from-transparent via-[#a855f7] to-transparent" data-id="element-267" />
            </div>
          </motion.div>
        </div>
      </div>

      {/* CTA Title + Carousel — LUXURY BLACK PANEL */}
      <div className="relative w-full overflow-hidden bg-black py-16 md:py-24" data-id="element-268">
        {/* Gold radial glows */}
        <div className="absolute -top-1/3 left-1/2 -translate-x-1/2 w-[900px] h-[700px] bg-[#D4AF37]/[0.14] rounded-full blur-[140px] pointer-events-none" data-id="element-269" />
        <div className="absolute -bottom-1/4 left-1/4 w-[500px] h-[400px] bg-[#D4AF37]/[0.10] rounded-full blur-[120px] pointer-events-none" data-id="element-270" />

        {/* Hairline borders */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" data-id="element-271" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent" data-id="element-272" />

        <h2 className="relative z-10 text-3xl md:text-5xl lg:text-6xl font-bold text-white text-center px-6 mb-4 leading-tight tracking-tight" style={{
        fontFamily: "'Playfair Display', Georgia, serif"
      }} data-id="element-273">
          Empezá hoy y construí{' '}
          <span className="bg-gradient-to-b from-[#F4D78A] via-[#D4AF37] to-[#9C7A1E] bg-clip-text text-transparent" data-id="element-274">
            una fuente de ingresos propia
          </span>{' '}
          paso a paso
        </h2>
        <p className="relative z-10 text-base md:text-lg text-white/70 text-center px-6 mb-12 font-medium" data-id="element-275">
          🔥 +1300 resultados reales de alumnos que están vendiendo sus ebooks
        </p>

        {/* Carousel - full width */}
        <div className="relative z-10 flex gap-4 overflow-x-auto cursor-grab active:cursor-grabbing snap-x snap-mandatory pl-6 pr-6" style={{
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-276">
          {[{
          type: 'video',
          src: 'https://cdn.magicpatterns.com/uploads/fgmiWFwxz9mdRLU5CZhwr7/VIDEODELTAPARACAMPAN%CC%83A.mp4'
        }, {
          type: 'image',
          src: 'https://cdn.magicpatterns.com/uploads/idppeFC4n7nsEuDs5UmUeB/Imagen_28-3-26_a_las_6.52_p._m..jpg'
        }, {
          type: 'image',
          src: 'https://cdn.magicpatterns.com/uploads/6TgDtquuyyH1mGpRCPs5Sw/Imagen_29-3-26_a_las_5.50_p._m..jpg'
        }, {
          type: 'image',
          src: 'https://cdn.magicpatterns.com/uploads/gjPNBPpsxnhmXt7P1dKUsv/Imagen_28-3-26_a_las_6.57_p._m..jpg'
        }].map((item, i) => <div key={i} className="flex-shrink-0 w-[30%] min-w-[260px] rounded-2xl overflow-hidden bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] border border-[#D4AF37]/40 shadow-[0_8px_40px_rgba(212,175,55,0.15)] snap-start p-3 flex items-center justify-center" data-id="element-277">
              {item.type === 'image' ? <img src={item.src} alt={`Resultado de alumno ${i + 1}`} className="w-full h-auto rounded-xl" draggable={false} data-id="element-278" /> : <video src={item.src} className="w-full h-auto rounded-xl" autoPlay muted loop playsInline data-id="element-279" />}
            </div>)}
        </div>
      </div>

      {/* ESTO ES PARA VOS SI... */}
      <div className="max-w-3xl mx-auto px-6 mt-14 mb-4" data-id="element-280">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-10" data-id="element-281">
          ESTO ES PARA VOS SI...
        </h2>
        <div className="space-y-6" data-id="element-282">
          {[{
          text: 'Tenés un ebook o querés crear uno, pero',
          bold: 'no sabés cómo venderlo ni por dónde empezar.'
        }, {
          text: 'Sentís que podrías',
          bold: 'generar ingresos con lo que sabés',
          after: ', pero la parte técnica te frena (tienda, pagos, automatización…).'
        }, {
          text: 'Sos emprendedor/emprendedora y hacés todo sola/o, y',
          bold: 'necesitás una forma simple de vender',
          after: ' sin agregar más tareas a tu rutina.'
        }, {
          text: 'Estás cansada/o de ver cursos que te dan vueltas, y',
          bold: 'querés una guía práctica, clara y directa',
          after: ' que puedas aplicar hoy mismo.'
        }, {
          text: 'Querés lanzar tu tienda digital, automatizar tus ventas y',
          bold: 'vender tu ebook 24/7',
          after: ' sin depender de Instagram o WhatsApp.'
        }].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-283">
              <span className="flex-shrink-0 w-10 h-10 bg-green-500 rounded-full flex items-center justify-center mt-0.5" data-id="element-284">
                <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-285">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-286" />
                </svg>
              </span>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-287">
                {item.text}{' '}
                <strong className="text-gray-900" data-id="element-288">{item.bold}</strong>
                {item.after || ''}
              </p>
            </div>)}
        </div>

        {/* Formula image */}
        <div className="mt-12 -mx-6 flex justify-center" data-id="element-289">
          <img src="https://cdn.magicpatterns.com/uploads/wHpW7BXKLYPuANXycsFkcU/3.png" alt="La fórmula paso a paso para lograr ventas en Shopify y en automático" className="w-full max-w-5xl h-auto" data-id="element-290" />
        </div>

        {/* Por qué deberías tener image */}
        <div className="mt-10 -mx-6 flex justify-center" data-id="element-291">
          <img src="https://cdn.magicpatterns.com/uploads/1rNYhV5bAdNqN9iExZgVRG/15.png" alt="¿Por qué deberías tener Vende tu Primer eBook en Shopify?" className="w-full max-w-5xl h-auto" data-id="element-292" />
        </div>

        {/* QUE VAS A LOGRAR */}
        <div className="mt-14 max-w-3xl mx-auto" data-id="element-293">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-8" data-id="element-294">
            QUE VAS A <span className="text-brand-green" data-id="element-295">LOGRAR</span>:
          </h2>
          <div className="space-y-4" data-id="element-296">
            {[{
            text: 'Tener tu',
            bold: 'tienda digital activa y lista para vender',
            after: ' en horas, aunque hoy no sepas nada de Shopify.'
          }, {
            text: 'Subir tu ebook y',
            bold: 'automatizar la entrega al comprador',
            after: ' sin depender de nadie más.'
          }, {
            text: 'Dejar de improvisar y usar una',
            bold: 'estructura probada que vende',
            after: '.'
          }, {
            text: '',
            bold: 'Evitar errores que te hacen perder ventas',
            after: ', como tener una página desordenada o cobrar mal.'
          }, {
            text: 'Lanzar sin miedo ni dudas, con una checklist que',
            bold: 'te guía paso a paso',
            after: '.'
          }, {
            text: '',
            bold: 'Vender tu ebook en piloto automático',
            after: ': la tienda trabaja por vos mientras vos hacés lo que amás.'
          }].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white border border-green-200 rounded-xl px-5 py-5" data-id="element-297">
                <span className="flex-shrink-0 w-10 h-10 bg-green-500 rounded-full flex items-center justify-center mt-0.5" data-id="element-298">
                  <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-299">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-300" />
                  </svg>
                </span>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-301">
                  {item.text}
                  {item.text ? ' ' : ''}
                  <strong className="text-brand-green" data-id="element-302">{item.bold}</strong>
                  {item.after}
                </p>
              </div>)}
          </div>
        </div>
      </div>

      {/* Video results title + video */}
      <div className="max-w-5xl mx-auto text-center relative z-10 px-6" data-id="element-303">
        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-304">
          <div className="relative text-center mb-8" data-id="element-305">
            <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-306" />
            <p className="text-3xl md:text-5xl lg:text-6xl font-bold text-brand-dark max-w-4xl mx-auto leading-tight relative z-10" data-id="element-307">
              Transforma tu conocimiento en{' '}
              <span className="text-[#1fa855]" data-id="element-308">ingresos reales</span> y empieza
              a construir un{' '}
              <span className="text-[#1fa855]" data-id="element-309">negocio digital</span> desde
              cero, sin complicaciones.
            </p>
          </div>

          <motion.h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 text-center mb-6 leading-tight" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-310">
            Descubrí cuánto facturé en menos de 3 meses{' '}
            <span className="text-[#1fa855]" data-id="element-311">CON 1 SOLO PRODUCTO</span>
          </motion.h2>

          <motion.p className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6" initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: 0.1
        }} data-id="element-312">
            Te doy el VERDADERO paso a paso para copiar y pegar.
            <br data-id="element-313" />
            En este video te enseño mis resultados ⬇
          </motion.p>

          <motion.div className="w-full max-w-3xl mx-auto mb-12 md:mb-16" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} data-id="element-314">
            <div className="relative w-full rounded-2xl bg-brand-card border border-gray-200 shadow-lg" style={{
            paddingBottom: '65%'
          }} data-id="element-315">
              <iframe src="https://fast.wistia.net/embed/iframe/9dsb5tsk42?seo=true&videoFoam=true" title="Video de presentación" allow="autoplay; fullscreen" allowFullScreen className="absolute top-0 left-0 w-full h-full rounded-2xl" style={{
              border: 'none'
            }} data-id="element-316" />
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* CTA Button and Feature Cards */}
      <div className="max-w-5xl mx-auto text-center relative z-10 px-6" data-id="element-317">
        <motion.div className="mt-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-318">
          <div className="mt-10 flex flex-col items-center" data-id="element-319">
            <a href="#" onClick={e => {
            e.preventDefault();
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="inline-block bg-brand-green hover:bg-brand-green-hover text-white font-bold text-xl px-16 py-5 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_0_40px_rgba(34,197,94,0.3)] hover:shadow-[0_0_60px_rgba(34,197,94,0.4)] cursor-pointer" data-id="element-320">
              🔥 Acceder Ahora
            </a>
            <p className="mt-5 text-gray-600 text-base md:text-lg font-medium" data-id="element-321">
              ⚡ Acceso Inmediato + De 0 a Escalado en Meta
            </p>

            {/* Feature Cards */}
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5 w-full max-w-5xl" data-id="element-322">
              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-323">
                <div className="flex items-start gap-3 mb-3" data-id="element-324">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-325">
                    <GraduationCapIcon className="w-5 h-5 text-brand-green" data-id="element-326" />
                  </div>
                  <div data-id="element-327">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-328">
                      Alumnos con resultados{' '}
                      <span className="text-brand-green" data-id="element-329">REALES</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-330">
                  Casos comprobados y testimonios verificables.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-331">
                <div className="flex items-start gap-3 mb-3" data-id="element-332">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-333">
                    <MessageCircleIcon className="w-5 h-5 text-brand-green" data-id="element-334" />
                  </div>
                  <div data-id="element-335">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-336">
                      Comunidad VIP en WhatsApp
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-337">
                  Soporte cercano y respuesta rápida 24/7.
                </p>
              </div>

              <div className="bg-brand-card border border-gray-200 rounded-2xl p-6 text-left shadow-sm" data-id="element-338">
                <div className="flex items-start gap-3 mb-3" data-id="element-339">
                  <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-340">
                    <VideoIcon className="w-5 h-5 text-brand-green" data-id="element-341" />
                  </div>
                  <div data-id="element-342">
                    <h3 className="text-gray-900 font-bold text-base" data-id="element-343">
                      Mentorías grupales semanales{' '}
                      <span className="text-brand-green" data-id="element-344">EN VIVO</span>
                    </h3>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-345">
                  Correcciones, estrategia y dudas resueltas en directo.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}